import React, { useEffect, useState } from "react";
import { X, Code, FileText } from "lucide-react";

function ViewRuleOutputPopup({ output, expectedOutput, ruleName, closePopup }) {
    const [actualValue, setActualValue] = useState(output || "");
    const [expectedValue, setExpectedValue] = useState(expectedOutput || "");

    useEffect(() => {
        document.body.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                closePopup();
            }
        };

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [closePopup]);

    useEffect(() => {
        setActualValue(output || "");
        setExpectedValue(expectedOutput || "");
    }, [output, expectedOutput]);

    return (
        <div className="oct-rule-output-modal" role="dialog" aria-modal="true" aria-labelledby="oct-rule-output-title">
            <div className="oct-rule-output-modal__backdrop" onClick={closePopup} />

            <div className="oct-rule-output-modal__dialog" onClick={(event) => event.stopPropagation()}>
                <div className="oct-rule-output-modal__header">
                    <div className="oct-rule-output-modal__header-glow" />

                    <div className="oct-rule-output-modal__title-wrap">
                        <div>
                            <h2 id="oct-rule-output-title" className="oct-rule-output-modal__title">
                                Rule Output
                            </h2>
                            {ruleName ? (
                                <p className="oct-rule-output-modal__subtitle">{ruleName}</p>
                            ) : null}
                        </div>
                    </div>

                    <button
                        type="button"
                        className="oct-rule-output-modal__close"
                        onClick={closePopup}
                        aria-label="Close rule output popup"
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-rule-output-modal__body">
                    <div className="oct-rule-output-modal__grid">
                        <div className="oct-rule-output-modal__panel">
                            <div className="oct-rule-output-modal__chip oct-rule-output-modal__chip--actual">
                                <Code size={16} />
                                <span>Actual Output</span>
                            </div>

                            <textarea
                                value={actualValue}
                                onChange={(event) => setActualValue(event.target.value)}
                                placeholder="No actual output available..."
                                rows={14}
                                className="oct-rule-output-modal__textarea"
                            />
                        </div>

                        <div className="oct-rule-output-modal__panel">
                            <div className="oct-rule-output-modal__chip oct-rule-output-modal__chip--expected">
                                <FileText size={16} />
                                <span>Expected Output</span>
                            </div>

                            <textarea
                                value={expectedValue}
                                onChange={(event) => setExpectedValue(event.target.value)}
                                placeholder="No expected output defined..."
                                rows={14}
                                className="oct-rule-output-modal__textarea"
                            />
                        </div>
                    </div>
                </div>

                <div className="oct-rule-output-modal__footer">
                    <button
                        type="button"
                        className="btn oct-rule-output-modal__btn"
                        onClick={closePopup}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ViewRuleOutputPopup;
